<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">المدن</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">المدن</li>
            </ol>
          </div>
        </div>
        <!-- FILTER -->
        <div class="card shadow card-warning card-outline mt-4">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">

                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم عربي - انجليزي">
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchRegaId" class="form-control" placeholder="كود هيئة العقار">
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchRegion">
                      <option :value="null">المنطقة</option>
                      <option v-for="r in regions" :key="r.id" :value="r.id">
                        {{ r.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchStatus">
                      <option :value="null">الحالة</option>
                      <option value="true">نشط</option>
                      <option value="false">غير نشط</option>
                    </select>
                  </div>

                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ التحديث</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer text-end">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('cities_create')" class="row">
          <div class="col text-end">
            <router-link to="/citieAdd" class="btn btn-primary rounded-pill">
              <i class="bi bi-plus-circle me-1"></i> إضافة مدينة
            </router-link>
          </div>
        </div>

        <div class="row justify-content-center mb-4 mt-5">
          <div class="col-12 col-md-11">
            <div v-if="hasError" class="text-center pt-3">
              <errorAlert :alertMessage= "message" />
            </div>
            <table class="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">الاسم عربي</th>
                  <th scope="col">الاسم انجليزي</th>
                  <th scope="col">المنطقة</th>
                  <th scope="col">الحاله</th>
                  <th scope="col">اخر تحديث</th>
                  <th scope="col">المدينة الإفتراضية</th>
                  <th v-if="checkAccess('cities_update')" scope="col">التعديل</th>
                  <th v-else scope="col">عرض</th>
                  <th v-if="checkAccess('cities_delete')" scope="col">الحذف</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in rows" :key="index">
                  <td class="counter"></td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.nameEn }}</td>
                  <td>{{ (row.Region)? row.Region.name : 'غير معروف' }}</td>
                  <td>{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                  <td>{{ $shortDate(row.updatedAt) }}</td>
                  <td v-if="row.isDefault"><i class="fa-solid fa-clipboard-check"></i></td>
                  <td v-if="!row.isDefault && checkAccess('cities_update')"><button type="button" class="btn btn-light btn-sm" @click="setDefaultCity(row.id, index)">ضبط كمدينة إفتراضية</button></td>
                  <td>
                    <router-link v-if="checkAccess('cities_update')" :to="'/citieupdate/'+row.id">
                      <i class="bi bi-card-list"></i>
                    </router-link>
                    <router-link v-else :to="'/cities/view/'+row.id">
                      <i class="fa-regular fa-eye"></i>
                    </router-link>
                  </td>
                  <td v-if="checkAccess('cities_delete')">
                    <a @click.prevent="deleteItem(index, row.id)">
                      <i class="bi bi-archive text-red pointer-mouse"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-11">
            <ul class="pagination">
              <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
              <li v-for="p in pages" :key="p" class="page-item">
                <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
              </li>
              <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
            </ul>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { toast, loaderToast, checkAccess } from '@/helpers/tools';
export default {
  name: "citiesview",
  data(){
    return {
      hasError: false,
      message: "",
      isLoading: false,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      searchName: this.$route.query.name || '',
      searchRegion: this.$route.query.region || null,
      searchStatus: this.$route.query.status || null,
      regions: [],
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      showDateFilter: false,
      searchRegaId: this.$route.query.regaId || '',
    }
  },
  methods: {
    checkAccess, 
    citiesList() {
      this.hasError = false;
      this.isLoading = true;
      let urlQuery = [`page=${this.currentPage}`];
      if (this.searchName)
        urlQuery.push(`name=${this.searchName}`);

      if (this.searchRegion)
        urlQuery.push(`regionId=${this.searchRegion}`);

      if (this.searchStatus !== null)
        urlQuery.push(`isActive=${this.searchStatus}`);

      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);

      if (this.searchRegaId.trim() != '')
        urlQuery.push(`regaId=${this.searchRegaId.trim()}`);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName   ? { name: this.searchName } : {}),
        ...(this.searchRegion !== null ? { region: this.searchRegion } : {}),
        ...(this.searchStatus !== null ? { status: this.searchStatus } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
        ...(this.searchRegaId.trim() ? { regaId: this.searchRegaId.trim() } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/cities/list?${urlQuery.join('&')}`).then(res => {
        this.isLoading = false;
        this.rows = res.data.cities;
        this.pages = res.data.pages ?? [this.currentPage];
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },

    deleteItem(index, id) {
      this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/cities/delete/${id}`).then(({data}) => {
            let buffer = this.rows;
            buffer.splice(index, 1);
            this.rows = buffer;
            // this.rows.splice(index, 1);
            toast('تم حذف السجل بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف السجل');
          });
        }
      });
    },

    setDefaultCity(id, indx){
      loaderToast('جاري الضبط كمدينة إفتراضية');
      this.$http.get(`/api/admin/cities/setDefault/${id}`).then(({data}) => {
        this.rows[indx].isDefault = true;
      }).catch(err => {
        toast('لدينا خطأ فني يرجى المحاولة في وقت لاحق');
      });
    },
    nextPage(){
      this.currentPage += 1;
      this.citiesList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.citiesList();
    },
    goToPage(num){
      this.currentPage = num;
      this.citiesList();
    },
    loadRegions(){
      this.$http.get('/api/admin/regions/list').then(res => {
        this.regions = res.data.regions; 
      });
    },
    filterSubmit(){
      this.currentPage = 1;
      this.citiesList();
    },
    clearFilter(){
      this.searchName = '';
      this.searchRegion = null;
      this.searchStatus = null;
      this.currentPage = 1;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchRegaId = '';
      this.$router.replace({ query: {} }).catch(() => {});
      this.citiesList();
    },
  },
  created() {
    this.loadRegions();
    this.citiesList();
  }
}
</script>